 <template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card title>
      <div v-if="order" class="mt-5">
        <div class="vx-row mb-6">
          <div class="vx-col">
            <p>Código Pedido:</p>
          </div>
          <div class="vx-col">
            <vs-chip color="success">{{order.idLaborOrder}}</vs-chip>
          </div>
          <div class="vx-col">
            <p>Cliente</p>
          </div>
          <div class="vx-col">
            <vs-chip color="success">{{order.corporateName}}</vs-chip>
          </div>
        
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col">
            <p>Etapa</p>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col">
            <vs-radio
              color="#1E90FF"
              v-model="newStage"
              vs-value="Conferência"
            >Conferência</vs-radio>
          </div>
          <div class="vx-col">
            <vs-radio color="success" v-model="newStage" vs-value="Faturamento">Faturamento</vs-radio>
          </div>
          <div class="vx-col">
            <vs-radio color="warning" v-model="newStage" vs-value="Estoque">Estoque</vs-radio>
          </div>
          <div class="vx-col">
            <vs-radio color="primary" v-model="newStage" vs-value="Concluído">Concluído</vs-radio>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col">
            <vs-list>
              <vs-list-header title="Histórico" color="danger"></vs-list-header>
              <div v-for="(item, index) of stages" :key="index">
                <vs-list-item icon-pack="feather" icon="icon-check" title="Data" :subtitle="item.date"></vs-list-item>
                <vs-list-item :title="item.userName" :subtitle="item.note">
                  <template slot="avatar">
                    <vs-avatar :src="item.photo" />
                  </template>
                </vs-list-item>
              </div>
            </vs-list>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
               <vs-input
                      class="w-full"
                      name="newNote"
                      label-placeholder="Observação" 
                      v-model="newNote"
                     />
          </div>
        </div>
        <vs-button class="mr-6" icon-pack="feather" icon="icon-save"  @click="submitData()">Salvar</vs-button>
      </div>
    </vx-card>
  </div>
</template> 
<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { momentJS } from "@/helpers";
import router from "@/router";
export default {
  data() {
    return {
      order: null,
      newStage: null,
      stages: [],
      newNote: null,
    };
  },
  methods: {
    async submitData() {
      try {
        if(!this.newNote){
          this.newNote = 'Nenhuma Observação'
        }
       
        let data = {
          order: {
            stage: this.newStage,
            idLaborOrder: this.order.idLaborOrder
          },
          stage: {
            note: `${this.newStage} - ${this.newNote}`,
            date: momentJS().getDateTime(),
            fk_idLaborOrder: this.order.idLaborOrder,
            fk_idUser: this.$store.state.user.idUser,
            fk_idCustomer: this.order.idCustomer
          }
           
        };
        this.$vs.loading();
        const response = await axios.post(
          `${baseApiUrl}/laborOrder/editStage`,
          data
        );
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success"
        });
      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      }
      this.$router.push(`/mao-de-obra`).catch(err => {});
    }
  },
  async created() {
    this.$vs.loading();
    const response = await axios.get(
      `${baseApiUrl}/laborOrder/getStageLaborOrderById/${this.$route.params.idLaborOrder}`
    );  
    //Format Date Moment
    response.data.stages.forEach(item => {
      item.date = momentJS().formatDateTimeForPTBR(item.date)
    });
    this.order = response.data.order;
    this.newStage = response.data.order.stage;
    this.stages = response.data.stages
    this.$vs.loading.close();
  }
};
</script> 
